export default function StatsSection() {
  const stats = [
    { icon: 'ri-file-list-3-line', value: '12,000+', label: '精选内容' },
    { icon: 'ri-user-heart-line', value: '80万+', label: '月活用户' },
    { icon: 'ri-shield-check-line', value: '99.9%', label: '服务稳定性' },
    { icon: 'ri-thumb-up-line', value: '98%', label: '用户好评率' },
  ];

  return (
    <section className="py-14 md:py-18 bg-primary-500">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-5">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
                <i className={`${stat.icon} text-xl text-background-50`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/70">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}